function setRestoreUserId({ input, state }) {
  state.set('login.recovery.restore._id', input.result._id)
}

export default setRestoreUserId



// WEBPACK FOOTER //
// ./src/modules/login/actions/setRestoreUserId.js